import React from "react";
import COR from "../../PicesForPages/CashOutRefinance.webp";
import FreeConsultation from "../Form/FreeConsultation";
import RefinanceCalculator from "../CalculatorAndChart/refinanceCalculator";

function CashOutRefinance() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="background-video aboutUsImage rightLoanForYouImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Cash Out Refinance</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span
              className="purchaseBottomLeftContent"
              style={{ color: "red" }}
            >
              Be aware that by refinancing your current loan, the total finance
              charges for the new loan might end up being higher over its
              duration.
            </span>

            <span className="purchaseBottomLeftContent">
              Please keep in mind that by refinancing your existing loan, you
              could face higher total finance charges for the new loan
              throughout its term.
            </span>

            <span className="purchaseBottomLeftHeader">
              What advantages does this offer?{" "}
            </span>
            <span className="purchaseBottomLeftContent">
              By tapping into the equity of your home, you can access cash from
              its value to settle debts or cover upcoming costs. The refinance
              process could also secure a more favorable mortgage interest rate,
              lowering your monthly payments. Additionally, the interest may be
              tax-deductible.
            </span>

            <span className="purchaseBottomLeftHeader">
              How can we assist you?
            </span>
            <span className="purchaseBottomLeftContent">
              If you’re interested in this type of refinancing,{" "}
              <span className="logoBoldColor">The Mortgageist</span>
              is ready to find a plan that aligns with your financial situation.
              We offer cash-out refinance programs for both owner-occupied and
              non-owner-occupied homes, featuring low and affordable rates.
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
      <RefinanceCalculator />
    </div>
  );
}

export default CashOutRefinance;
